/* --------------------------------------------------------------------------
	Menu
-------------------------------------------------------------------------- */

"use strict";

var $ = jQuery;
import {
	saveScrollYPosition,
	getScrollbarWidth,
	restoreScrollYPosition,
} from "../base/page.js";
import "../base/swap.js";

var $Menu,
	$MenuClose,
	$MenuToggle,
	$AudienceToggle,
	$ShiftingElements,
	ToggleStatus,
	LockClass;

function initMenu() {
	$Menu = $(".js-menu");

	if (!$Menu.length) {
		return;
	}

	$MenuToggle = $(".js-menu-toggle");
	$MenuClose = $(".js-menu-close-toggle");
	$AudienceToggle = $(".js-audience-toggle");
	$ShiftingElements = $(".header, .page, .footer");
	ToggleStatus = false;
	LockClass = "fs-page-lock";

	$Menu.find(".js-nav-link, button, input").attr("tabindex", "-1");
	$Menu
		.on("keydown", onMenuKeydown)
		.on("keyup", onMenuKeyup)
		.attr("aria-hidden", "true");

	$MenuToggle
		.on("activate.swap", onMenuSwapActivate)
		.on("deactivate.swap", onMenuSwapDeactivate)
		.attr({ "aria-expanded": "false", role: "button" });

	$MenuClose.on("keydown", onCloseKeydown).on("click", onMenuSwapDeactivate);

	$(document).on("click touchstart", onDocumentClick);

	$(window).on("resize", onWindowResize);
}

function onWindowResize() {
	// Only apply the logic if the campaign site is active
	// if ($('.campaign-site-menu').length > 0 && $(window).width() >= 980) {
	// if ($(window).width() >= 980) {
	// 	// If the menu is active, deactivate it
	// 	if (ToggleStatus === true) {
	// 		$MenuToggle.swap("deactivate");

	// 		// Optionally focus back on the main content after closing the menu
	// 		// $('body').focus();
	// 	}
	// }
	var viewportWidth = window.innerWidth; // More consistent across platforms
	if (viewportWidth >= 980) {
		// If the menu is active, deactivate it
		if (ToggleStatus === true) {
			$MenuToggle.swap("deactivate");
		}
	}
}

function onDocumentClick(e) {
	if ($("body").hasClass(LockClass)) {
		if (!$(e.target).closest(".js-menu").length) {
			$MenuToggle.swap("deactivate");
		}
	}
}

function onMenuSwapActivate() {
	if (ToggleStatus == false) {
		saveScrollYPosition();
		ToggleStatus = true;
	}

	$("body").addClass(LockClass);

	$MenuToggle.attr("aria-expanded", "true");

	$Menu
		.attr({ "aria-hidden": "false", tabindex: "0" })
		.one("transitionend", function () {
			$Menu.focus();
		})
		.find(".js-nav-link, button, input")
		.removeAttr("tabindex");

	$ShiftingElements.css("padding-right", getScrollbarWidth());

	$Menu.css({
		"margin-right": "",
		width: "",
	});

	$AudienceToggle.swap("deactivate");
}

function onMenuSwapDeactivate() {
	$("body").removeClass(LockClass);

	if (ToggleStatus == true) {
		restoreScrollYPosition();
		ToggleStatus = false;
	}

	$Menu
		.attr("aria-hidden", "true")
		.removeAttr("tabindex")
		.find(".js-nav-link, button, input")
		.attr("tabindex", "-1");

	$MenuToggle.attr("aria-expanded", "false").focus();

	$ShiftingElements.css("padding-right", "");

	$Menu.css({
		"margin-right": getScrollbarWidth() * -1,
		width: "calc(100% + " + getScrollbarWidth() + "px)",
	});
}

function onCloseKeydown(e) {
	// tab
	if (e.keyCode === 9) {
		if (!e.shiftKey) {
			$Menu.focus();
		}
	}
}

function onMenuKeydown(e) {
	if ($Menu.is(":focus")) {
		// tab
		if (e.keyCode === 9) {
			if (e.shiftKey) {
				e.preventDefault();

				$MenuClose.focus();
			}
		}
	}
}

function onMenuKeyup(e) {
	// escape
	if (e.keyCode === 27) {
		$MenuToggle.swap("deactivate");
	}
}

$(initMenu);
